<template>
<div class="chapter">
<div class="inner_page">
<div id="fm2">
<p class="title"><span class="bold">Gryphon in Glory</span></p>
<p class="title1"><span class="bold">A Witch World Book</span></p>
<p class="title2">Andre Norton</p>
<p class="titlea"><img alt="" class="figure" src="images/fig_02.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?d6ebb0f8